(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["about-ceo-message-section"] && !window.DesignMode) return;
  try {
    
  $('.founder-slides-cont').slick({ 
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
  });

$(document).ready(function () {

  $('.founder-details .see-more').on('click',function(){  
    $('.about-rempah-sec').toggleClass('show-full-about-rempah-sec');
    if ($('.about-rempah-sec').hasClass('show-full-about-rempah-sec')) {
        $(".poly-up").css("transform", "rotate(180deg)");
        $('.founder-details .see-more p').text('Close');
        $('.founder-details .see-more p').css('order', '2');
        $('.founder-details .see-more img').css('order', '1');
    } else {
        $('.founder-details .see-more p').text('Open')
        $(".poly-up").css("transform", "rotate(0deg)");
        $('.founder-details .see-more p').css('order', '1');
        $('.founder-details .see-more img').css('order', '2');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["articles-slider"] && !window.DesignMode) return;
  try {
    
  $('.articles-section-slider').slick({
    mobileFirst: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    infinite: true,
    cssEase: "linear",
    autoplay: false,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          infinite: true,
          cssEase: "linear",
          autoplay: false,
          focusOnSelect: false,
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-articles"] && !window.DesignMode) return;
  try {
    
    window.addEventListener('DOMContentLoaded', () => {
      $('.featured-articles__list').slick({
          slidesToShow: 1.35,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          infinite: false,
          cssEase: "linear",
          mobileFirst: true,
          responsive: [
              {
                  breakpoint: 575,
                  settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  },
              },
              {
                  breakpoint: 991,
                  settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  },
              },
          ],
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flavors-list"] && !window.DesignMode) return;
  try {
    
    window.addEventListener('DOMContentLoaded', () => {
        $('.flavors-list__items').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            cssEase: "linear",
            prevArrow: $('.slick-prev--custom'),
            nextArrow: $('.slick-next--custom'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        asNavFor: '.flavors-list__items--nav'
                    }
                }
            ]
        });
        $('.flavors-list__items--nav').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.flavors-list__items'
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flavors"] && !window.DesignMode) return;
  try {
    
    window.addEventListener('DOMContentLoaded', () => {
        $('.flavors__grid-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            cssEase: "linear",
            prevArrow: $('.slick-prev--rounded'),
            nextArrow: $('.slick-next--rounded')
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-bundle-flavours"] && !window.DesignMode) return;
  try {
    
  $('.homiah-flavours-section-slider').slick({
    mobileFirst: true,
    cssEase: "linear",
    centerMode: false,
    dots: false,
    arrows: true,
    swipe: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: false,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-reviews"] && !window.DesignMode) return;
  try {
    
  $('.slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    cssEase: "linear",
    autoplay: true,
    focusOnSelect: false
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    $('.spice-kit-section-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      cssEase: "linear",
      asNavFor: '.spice-kit-section-slider-bottom'
    });
    $('.spice-kit-section-slider-bottom').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      arrows: false,
      swipe: false,
      cssEase: "linear",
      asNavFor: '.spice-kit-section-slider',
      focusOnSelect: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["PDP-goodies-section"] && !window.DesignMode) return;
  try {
    
  $('.goodies-section-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    centerMode: false,
    infinite: true,
    cssEase: "linear",
    autoplay: false,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          centerMode: true,
          infinite: true,
          cssEase: "linear",
          autoplay: false,
          variableWidth: true,
          arrows: false,
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["PDP-section-flavor"] && !window.DesignMode) return;
  try {
    
  let currentWidth = window.innerWidth;
  function checkMediaQuery() {
    if (window.innerWidth !== currentWidth && window.innerWidth < 768) {
      location.reload();
    } else {
      currentWidth = window.innerWidth;
    }
  }
  window.addEventListener('resize', checkMediaQuery);

  $('.flavour-section-flavourList').slick({
    mobileFirst: true,
    arrows: true,
    centerMode: true,
    focusOnSelect: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    infinite: true,
    autoplay: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 767,
        settings: "unslick",
        cssEase: "linear",
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        swipe: true,
        swipeToSlide: false,
        variableWidth: true,
      },
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-basic"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    $('.spice-kit-section-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      cssEase: "linear",
      asNavFor: '.spice-kit-section-slider-bottom'
    });
    $('.spice-kit-section-slider-bottom').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      arrows: false,
      swipe: false,
      cssEase: "linear",
      asNavFor: '.spice-kit-section-slider',
      focusOnSelect: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-default"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    $('.spice-kit-section-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      cssEase: "linear",
      asNavFor: '.spice-kit-section-slider-bottom'
    });
    $('.spice-kit-section-slider-bottom').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      arrows: false,
      swipe: false,
      cssEase: "linear",
      asNavFor: '.spice-kit-section-slider',
      focusOnSelect: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-flavors-multiply"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    $('.spice-kit-section-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      cssEase: "linear",
      asNavFor: '.spice-kit-section-slider-bottom'
    });
    $('.spice-kit-section-slider-bottom').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      arrows: false,
      swipe: false,
      cssEase: "linear",
      asNavFor: '.spice-kit-section-slider',
      focusOnSelect: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-packs-multiply"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    $('.spice-kit-section-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      cssEase: "linear",
      asNavFor: '.spice-kit-section-slider-bottom'
    });
    $('.spice-kit-section-slider-bottom').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      arrows: false,
      swipe: false,
      cssEase: "linear",
      asNavFor: '.spice-kit-section-slider',
      focusOnSelect: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-preview-packs-multiply"] && !window.DesignMode) return;
  try {
    
    window.addEventListener('DOMContentLoaded', () => {
        $('.preview__gallery--packs').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            cssEase: "linear"
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-preview"] && !window.DesignMode) return;
  try {
    
    window.addEventListener('DOMContentLoaded', () => {
        $('.preview__gallery').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            cssEase: "linear"
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-with-rating"] && !window.DesignMode) return;
  try {
    
    $('.reviews-rating__list').slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        cssEase: "linear",
        autoplay: true,
        focusOnSelect: false
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !window.DesignMode) return;
  try {
    
    $('.reviews__list').slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        cssEase: "linear",
        autoplay: true,
        focusOnSelect: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick",
            },
        ],
    });

  } catch(e) { console.error(e); }
})();
      })();
